import { ReactNode } from 'react'

import { wwtMemo } from '@wwt/custom/wwt'

interface GuestInformationGridProps {
	children: ReactNode
}

/**
 * Component for show elements(@GuestInformationGridElement) in grid
 * on reservation tab
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationGrid = wwtMemo(
	({ children }: GuestInformationGridProps) => {
		return (
			<div className="grid grid-cols-1 gap-x-10 gap-y-3 sm:grid-cols-2">
				{children}
			</div>
		)
	}
)
